import { jsx as a } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { Box as d } from "../box/Box.js";
import { twMerge as c } from "tailwind-merge";
const g = n((o, t) => {
  const { size: r, variant: e = "primary", className: s, children: i, ...m } = o;
  return /* @__PURE__ */ a(
    d,
    {
      ref: t,
      className: c(
        "flex aspect-square flex-shrink-0 items-center justify-center",
        //
        r === "sm" && "size-8 rounded-md",
        r === "md" && "size-10 rounded-lg",
        r === "lg" && "size-12 rounded-xl",
        //
        e === "primary" && "[&>*]:text-brand-violet-primary bg-white",
        e === "secondary" && "border-none bg-gray-100 [&>*]:!text-gray-500",
        //
        s
      ),
      ...m,
      children: i
    }
  );
});
export {
  g as BoxIcon
};
